import React, { useEffect, useState } from "react";
// React Bootstrap
import { Navbar, Image, Form, FormControl, InputGroup } from "react-bootstrap";
// Componentes
import GenericExplorer from "../generic/GenericExplorer";
import HermanaTarjeta from "./HermanaTarjeta";
import HermanaAddTarjeta from "./HermanaAddTarjeta";
import TooltipIcon from "../generic/TooltipIcon";
// Jquery
import $ from "jquery";
// Styled Components
import styled from "styled-components";

const CustomNavBar = styled(Navbar)`
  /* padding: 0px;
  margin: 0px; */
  min-width: 200px;
`;

const Hermanas = ({provinciaLogueado, ...props }) => {
  //console.log(provinciaLogueado)

  //Filters
  const [search, setSearch] = useState("");
  const [filterProvincia, setFilterProvincia] = useState("");
  const [filterComunidad, setFilterComunidad] = useState("");
  // Selects' data
  const [provincias, setProvincias] = useState([]);
  const [comunidades, setComunidades] = useState([]);
  const [todasHermanas, setTodasHermanas] = useState(false);

  const handleChangeSearch = (e) => {
    setSearch(e.target.value);


  };
  const handleChangeProvincia = (e) => {
    setFilterComunidad("");
    setComunidades([]);
    setFilterProvincia(e.target.value);
  };
  const handleChangeComunidad = (e) => {
    setFilterComunidad(e.target.value);
  };
  const handleChangeTodasHermanas = () => {
    setTodasHermanas(!todasHermanas);
  };

  // UEF para obtener los datos de la provincia
  useEffect(() => {
    handleGetDatosProvincia();
  }, []);

  // UEF para l
  useEffect(() => {
    filterProvincia && handleGetDatosComunidad();
  }, [filterProvincia]);

  //********************************************** REQUESTS ****************************************************
  //------------------------------------------------ GET -------------------------------------------------------
  // Obtiene todas las provincias
  const getDatosProvincias = () => {
    //console.log('hola q tal provincias')
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/provincias?ended=false`,
      method: "GET",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  };
  // Obtiene todas las comunidades de una provincia
  const getDatosComunidades = () => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/provincias/${filterProvincia}/comunidades`,
      method: "GET",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  };
  //********************************************** HANDLERS ****************************************************/
  //------------------------------------------------ GET -------------------------------------------------------
  // Manejador para obtener los datos de la misión
  const handleGetDatosProvincia = () => {
    getDatosProvincias()
      .then((response) => {
        
        setProvincias(response.items);
      })
      .catch(() => {
        props?.ErrorHandling();
      });
  };

  const handleGetDatosComunidad = () => {
    getDatosComunidades()
      .then((response) => {
        setComunidades(response.items);
      })
      .catch(() => {
        props?.ErrorHandling();
      });
  };

  //**************************************************************************************************/

  // A partir de los valores de los filtros obtiene el query string
  const getQueryString = () => {
    let count = "20";
    let type = "Monja";
    let findName = search ? search : "";
//console.log(`?count=${count}&type=${type}&findName=${findName}&provincia=${filterProvincia}&comunidad=${filterComunidad}&allUser=${todasHermanas}`)
    return `?count=${count}&type=${type}&findName=${findName}&provincia=${filterProvincia}&comunidad=${filterComunidad}&allUser=${todasHermanas}`;
  };

  return (
    <div>
      <h2>Hermanas</h2>
     
      <GenericExplorer className={'m-1'} url={`/usuarios${getQueryString()}`} ItemAddCard={HermanaAddTarjeta} userLevel={props.userLevel} provinciaLogueado={provinciaLogueado}  ItemCard={HermanaTarjeta}>
        <CustomNavBar expand="md">
          {/* Cuando se hace pequeña la pantalla */}
          <Navbar.Toggle aria-controls="Filtro Hermanas" className="bg-light mb-3">
            <Image className="align-text-top" alt="" height="20" />
            <span className="align-text-bottom"> Filtros</span>
          </Navbar.Toggle>
          {/*          */}
          <Navbar.Collapse className="mb-3" id="basic-navbar-nav">
            <Form as="div" inline className="w-100">
              <FormControl type="text" onChange={handleChangeSearch} placeholder={"Búsqueda"} />
              <TooltipIcon className={"mr-3 ml-1 pb-1"} content={"Búsqueda por nombre, apellidos o documento de identidad."} />
              <InputGroup className="mr-3">
                <InputGroup.Prepend>
                  <InputGroup.Text>Provincias</InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control as="select" onChange={handleChangeProvincia} custom value={filterProvincia}>
                  <option value="">Todas</option>
                  {provincias.length &&
                    provincias.map((provincia) => {
                      return (
                        <option key={provincia.id} value={provincia.id}>
                          {provincia.name}
                        </option>
                      );
                    })}
                </Form.Control>
              </InputGroup>
              <InputGroup className="mr-3">
                <InputGroup.Prepend>
                  <InputGroup.Text>Comunidades</InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control as="select" onChange={handleChangeComunidad} value={filterComunidad} custom>
                  <option value="">Todas</option>
                  {comunidades.length &&
                    comunidades.map((comunidad) => {
                      return (
                        <option key={comunidad.id} value={comunidad.id}>
                          {comunidad.name}
                        </option>
                      );
                    })}
                </Form.Control>
              </InputGroup>
              <InputGroup className="mt-2">
                <Form.Group>
                  <Form.Check type="checkbox" label="Todas las hermanas" defaultChecked={todasHermanas} value={todasHermanas} onClick={handleChangeTodasHermanas} />
                  <TooltipIcon className={"ml-1 pb-1"} content={"Al seleccionar esta opción se muestran las hermanas fallecidas o fuera de la congregación (Secularización o paso a otro instituto)"} />
                </Form.Group>
              </InputGroup>
            </Form>
          </Navbar.Collapse>
        </CustomNavBar>
      </GenericExplorer>
    </div>
  );
};

export default Hermanas;
